// extracted by mini-css-extract-plugin
export default {"main":"ItemsNav_main__Exj1U","mainHidden":"ItemsNav_mainHidden__2O+bF","container":"ItemsNav_container__7SvUT","exclusiveBtn":"ItemsNav_exclusiveBtn__Y3C0E"};